
import { useState } from "react";
import "react-multi-date-picker/styles/backgrounds/bg-dark.css";
import { Link } from "react-router-dom";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import Button from "../../../common/button/Button";

export default function EpisodeAction({ episode, onReloadNeeded }) {
	const [isRemoveOpen, setIsRemoveOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	const handleRemove = () => {
		if (isLoading) return;
		setIsLoading(true);
		api.episodeRemove({
			token: LoginHelper.getToken(),
			episode_id: episode.id,
		}).then((result) => {
			setIsLoading(false);
			onReloadNeeded();
		}).catch((err) => {
			setIsLoading(false);
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		});
	}

	return (
		<div>
			<div className="spacer p-[10px]"></div>
			<div className="flex flex-row justify-start items-center">
				<Link to={`/episode_edit/${episode.id}/`} className="text-[#4B5155] font-Vazir-800 text-[14px] rounded-[10px] bg-[#F0F6FC] px-[10px] py-[5px]">
					ویرایش
				</Link>
				<div className="spacer p-[2px]"></div>
				<div className="cursor-pointer text-white font-Vazir-800 text-[14px] rounded-[10px] bg-[#CC0000] px-[10px] py-[5px]" onClick={() => setIsRemoveOpen(!isRemoveOpen)}>
					حذف
				</div>
			</div>
			{isRemoveOpen && (
				<>
					<div className="spacer p-[15px]"></div>
					<div>
						<div className="text-[#4B5155] font-Vazir-800 text-[14px]">
							آیا از حذف قسمت مطمئن هستید؟
						</div>
						<div className="spacer p-[5px]"></div>
						<div className="flex flex-row items-center">
							<div className="cursor-pointer text-[#4B5155] font-Vazir-800 text-[14px] rounded-[10px] bg-[#F0F6FC] px-[10px] py-[5px]"
								onClick={() => setIsRemoveOpen(!isRemoveOpen)}>
								خیر
							</div>
							<div className="spacer p-[2px]"></div>
							<div className="min-w-[50px] h-[30px]">
								<Button
									onClick={() => { handleRemove() }}
									label={"بله"}
									isLoading={isLoading}
									color="#CC0000"
									textColor="#ffffff"
								/>
							</div>
						</div>
					</div>
				</>
			)}
			{errorMessage && (
				<div className="text-center font-Vazir-400 text-[#cc0000]">{errorMessage}</div>
			)}
		</div>
	)
}
